// Fuseau horaire de Mayotte (UTC+3)
export const TZ = 'Indian/Mayotte';

/**
 * Formate une date en francais avec le fuseau de Mayotte.
 * @param {string|Date} d - date ISO ou objet Date
 * @param {object} opts - options Intl.DateTimeFormat (sans timeZone)
 * @returns {string}
 */
export function fmtDateTZ(d, opts = {}) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR', { timeZone: TZ, ...opts });
}

/**
 * Formate une heure en francais avec le fuseau de Mayotte.
 */
export function fmtTimeTZ(d, opts = {}) {
  if (!d) return '—';
  return new Date(d).toLocaleTimeString('fr-FR', { timeZone: TZ, ...opts });
}

/**
 * Formate date + heure courte (jour mois, hh:mm)
 */
export function fmtDateTimeTZ(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR', {
    timeZone: TZ,
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Retourne la date du jour a Mayotte au format YYYY-MM-DD
 */
export function todayMayotte() {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(new Date());
  return parts; // en-CA gives YYYY-MM-DD
}
